import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { translate } from 'parking-react-common'

import { filters, ui } from '../redux'

import Button from '../components/Button'

const FiltersButton = ({ dispatch, isActive, t }) => (
    <Button
        intent={ isActive ? ui.INTENT.primary : ui.INTENT.default }
        size={ ui.SIZE.large }
        icon="fa/filter"
        label={ t('Filter') }
        onClick={ () => dispatch(filters.toggle()) }
    />
)

FiltersButton.propTypes = {
    isActive: PropTypes.bool
}

function mapStateToProps(state) {
    return {
        isActive: filters.isOpen(state)
    }
}

export default compose(
    translate(),
    connect(mapStateToProps)
)(FiltersButton)
